import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'
import {DeleteLeadNatureModel} from '../Model'
import {LeadNatureModel} from '../Model/LeadNatureModel'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const LEAD_NATURE = `${API_URL}/lead-form/nature`

export const service = {
  getLeadNature: (params: ParamsModel) => {
    return axios.get(LEAD_NATURE, {params})
  },
  getAllLeadNature: () => {
    return axios.get(`${LEAD_NATURE}/list`)
  },

  addLeadNature: (data: any) => {
    return axios.post(LEAD_NATURE, data)
  },

  updateLeadNature: (body: LeadNatureModel, id: string) => {
    return axios.put(`${LEAD_NATURE}/${id}`, body)
  },

  deleteLeadNature: (data: DeleteLeadNatureModel) => {
    return axios.delete(`${LEAD_NATURE}/bulk-delete`, {data})
  },

  enableLeadNature: (data: Array<string>) => {
    const selectedLeadNature = {
      nature: data,
    }
    return axios.put(`${LEAD_NATURE}/bulk-active`, selectedLeadNature)
  },

  disableLeadNature: (data: Array<string>) => {
    const selectedLeadNature = {
      nature: data,
    }
    return axios.put(`${LEAD_NATURE}/bulk-inactive`, selectedLeadNature)
  },

  singleEnableLeadNature: (data: Array<string>) => {
    const selectedLeadNature = {
      nature: [data],
    }
    return axios.put(`${LEAD_NATURE}/bulk-active`, selectedLeadNature)
  },

  singleDisableLeadNature: (data: Array<string>) => {
    const selectedLeadNature = {
      nature: [data],
    }
    return axios.put(`${LEAD_NATURE}/bulk-inactive`, selectedLeadNature)
  },
}

